.container {
  padding-block-start: var(--dds-spacing-x3);
  padding-block-end: var(--dds-spacing-x6);

  @media only screen and (min-width: 960px) {
    padding-block: var(--dds-spacing-x4);
  }
}

.left {
  display: flex;
  flex-direction: column;
  gap: var(--dds-spacing-x4);
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--dds-spacing-x1-5);
}

.list-group {
  display: flex;
  flex-direction: column;
  gap: var(--dds-spacing-x1-5);
}

.socials-group {
  display: flex;
  flex-direction: column;
  gap: var(--dds-spacing-x1);
}

.socials-list {
  display: flex;
  gap: var(--dds-spacing-x1-5);
}
